import { EventType, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';
import { ValidationEventInfo } from './types';

const event = ({ validationError, trackingParams, sourcePage }: ValidationEventInfo): EventData => {
  return {
    event_type: EventType.appEvent,
    source_page: sourcePage,
    feature: Features.leadForm,
    app_event_type: validationError ? 'name_is_invalid' : 'name_is_valid',
    event_context: {
      tracking_params: trackingParams,
    },
  };
};

export default event;
